(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
if (!customElements.get("c-cart-item")) {
  customElements.define(
    "c-cart-item",
    class ComponentPopupLineItem extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.lineId = this.dataset.id;

        // qty var
        this.qtyInput = this.querySelector('.js-cart-item__form-qty-input');
        this.qtyButtonPlus = this.querySelector('.js-cart-item__form-qty-button--plus');
        this.qtyButtonMinus = this.querySelector('.js-cart-item__form-qty-button--minus');

        this.removeBtn = this.querySelector('.js-cart-item__remove');

        this.removeBtn?.addEventListener('click', this.removeBtnClickHandler);
        
        this.qtyButtonPlus?.addEventListener('click', this.qtyButtonPlusClickHandler);
        this.qtyButtonMinus?.addEventListener('click', this.qtyButtonMinusClickHandler);
        this.qtyInput?.addEventListener('change', this.qtyInputChangeHandler);
      }

      disconnectedCallback() {
        this.qtyButtonPlus?.removeEventListener('click', this.qtyButtonPlusClickHandler);
        this.qtyButtonMinus?.removeEventListener('click', this.qtyButtonMinusClickHandler);
        this.qtyInput?.removeEventListener('change', this.qtyInputChangeHandler);

        this.removeBtn?.removeEventListener('click', this.removeBtnClickHandler);
      }

      removeBtnClickHandler = () => {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            updates: {
              [this.lineId]: 0
            }
          })
        })
        .then(response => response.json())
        .then(data => {
          window.PubSub.publish('cart:update', "");
        })
        .catch(error => {
          console.error('Error:', error)
        });
      }

      qtyInputChangeHandler = () => {

        if (parseInt(this.qtyInput.value) > parseInt(this.qtyInput.max)) {
          this.qtyInput.value = this.qtyInput.max
        }
  
        if (parseInt(this.qtyInput.value) < parseInt(this.qtyInput.min)) {
          this.qtyInput.value = this.qtyInput.min
        }
  
        if (parseInt(this.qtyInput.value) === parseInt(this.qtyInput.max)) {
          this.qtyButtonPlus.classList.add('c-cart-item__form-qty-button--disabled')
        } else {
          this.qtyButtonPlus.classList.remove('c-cart-item__form-qty-button--disabled')
        }
  
        if (parseInt(this.qtyInput.value) === parseInt(this.qtyInput.min)) {
          this.qtyButtonMinus.classList.add('c-cart-item__form-qty-button--disabled')
        } else {
          this.qtyButtonMinus.classList.remove('c-cart-item__form-qty-button--disabled')
        }
  
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            updates: {
              [this.lineId]: parseInt(this.qtyInput.value)
            }
          })
        })
        .then(response => response.json())
        .then(data => {
          window.PubSub.publish('cart:update', "");
        })
        .catch(error => {
          console.error('Error:', error)
        });
      }

      qtyButtonPlusClickHandler = () => {
        this.qtyInput.value = parseInt(this.qtyInput.value) + 1
  
        this.qtyInput.dispatchEvent(new Event('change'))
      }
  
      qtyButtonMinusClickHandler = () => {
        this.qtyInput.value = parseInt(this.qtyInput.value) - 1
  
        this.qtyInput.dispatchEvent(new Event('change'))
      }
    }
  );
}



},{}]},{},[1])

